export default __webpack_public_path__ + "static/centered-results-3-155804d0cb9a241287248d8337295f3e.png";